/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Session_Minutes_30Inputs */

const en_us2_onboarding_session_minutes_30 = /** @type {(inputs: Onboarding_Session_Minutes_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up to 30 min`)
};

const pt_br2_onboarding_session_minutes_30 = /** @type {(inputs: Onboarding_Session_Minutes_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Até 30 min`)
};

const es_419_onboarding_session_minutes_30 = /** @type {(inputs: Onboarding_Session_Minutes_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasta 30 min`)
};

const pt_pt2_onboarding_session_minutes_30 = /** @type {(inputs: Onboarding_Session_Minutes_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Até 30 min`)
};

const fr_fr2_onboarding_session_minutes_30 = /** @type {(inputs: Onboarding_Session_Minutes_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jusqu'à 30 min`)
};

const de_de2_onboarding_session_minutes_30 = /** @type {(inputs: Onboarding_Session_Minutes_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis 30 min`)
};

const it_it2_onboarding_session_minutes_30 = /** @type {(inputs: Onboarding_Session_Minutes_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fino a 30 min`)
};

/**
* | output |
* | --- |
* | "Up to 30 min" |
*
* @param {Onboarding_Session_Minutes_30Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_session_minutes_30 = /** @type {((inputs?: Onboarding_Session_Minutes_30Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Session_Minutes_30Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_session_minutes_30(inputs)
	if (locale === "es-419") return es_419_onboarding_session_minutes_30(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_session_minutes_30(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_session_minutes_30(inputs)
	if (locale === "de-DE") return de_de2_onboarding_session_minutes_30(inputs)
	if (locale === "it-IT") return it_it2_onboarding_session_minutes_30(inputs)
	return en_us2_onboarding_session_minutes_30(inputs)
});
export { onboarding_session_minutes_30 as "onboarding.session_minutes.30" }